import { createSlice } from "@reduxjs/toolkit";
import {
  fetchUserTypeById,
  fetchUserTypeDropdown,
  fetchUserTypeList,
  updateUserType,
  updateUserTypeStatus,
} from "./thunk";

interface UserTypeState {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedUserType: any;
  dropDown: any[];
}

const initialState: UserTypeState = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedUserType: null,
  dropDown: [],
};

const userTypeSlice = createSlice({
  name: "UserType",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch All Organisations
      .addCase(fetchUserTypeList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserTypeList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = Array.isArray(action.payload.data)
          ? action.payload.data
          : [];
        state.rowCount =
          typeof action.payload.rowCount === "number"
            ? action.payload.rowCount
            : 0;
      })
      .addCase(fetchUserTypeList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch organisations";
      })

      // Fetch Single Organisation by ID
      .addCase(fetchUserTypeById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserTypeById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedUserType = action.payload?.data;
      })
      .addCase(fetchUserTypeById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Update Organisation
      .addCase(updateUserType.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.list = state.list.map((type) =>
          type.user_type_id === action.payload.user_type_id
            ? action.payload
            : type
        );
      })
      .addCase(updateUserType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update organisation";
      })

      // Active organizations
      // Fetch Organization Dropdown
      .addCase(fetchUserTypeDropdown.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserTypeDropdown.fulfilled, (state, action) => {
        state.loading = false;
        state.dropDown = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchUserTypeDropdown.rejected, (state, action) => {
        state.loading = false;
        state.error =
          typeof action.payload === "string"
            ? action.payload
            : action.error.message || "Failed to fetch organization dropdown";
      })

      // Update Status
      .addCase(updateUserTypeStatus.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.list = state.list.map((type) =>
          type.user_type_id === action.payload.user_type_id
            ? action.payload
            : type
        );
      })
      .addCase(updateUserTypeStatus.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to update organisation status";
      });
  },
});

export default userTypeSlice.reducer;
